import { createTicketsSlaInsightsApi } from './insights';
export * from './insights';
var relativePath = '/sla';
var slaV2 = '/new';
export var createSlaApi = function (baseUrl, http) {
    var apiUrl = baseUrl + relativePath;
    var apiUrlNew = baseUrl + relativePath + slaV2;
    return {
        getAll: function () {
            return http.get(apiUrl);
        },
        getAllV2: function () {
            return http.get(apiUrlNew);
        },
        get: function (slaPolicyDto) {
            return http.get(apiUrl + "/" + slaPolicyDto.id);
        },
        add: function (addSlaPolicyDto) {
            return http.post("" + apiUrl, addSlaPolicyDto);
        },
        addV2: function (addV2SlaPolicyDto) {
            return http.post("" + apiUrlNew, addV2SlaPolicyDto);
        },
        enable: function (enableSlaPolicyDto) {
            return http.put(apiUrl + "/" + enableSlaPolicyDto.id + "/enable", enableSlaPolicyDto);
        },
        update: function (updateSlaPolicyDto) {
            return http.put(apiUrl + "/" + updateSlaPolicyDto.id, updateSlaPolicyDto);
        },
        updateV2: function (updateV2SlaPolicyDto) {
            return http.put(apiUrlNew + "/" + updateV2SlaPolicyDto.id, updateV2SlaPolicyDto);
        },
        delete: function (deleteSlaPolicyDto) {
            return http.delete(apiUrl + "/" + deleteSlaPolicyDto.id);
        },
        reorder: function (reorderSlaPolicyDto) {
            return http.post(apiUrl + "/reorder", reorderSlaPolicyDto);
        },
        insights: createTicketsSlaInsightsApi(baseUrl, http)
    };
};
//# sourceMappingURL=index.js.map